export default __webpack_public_path__ + "static/pago-b1437138af8877d3b698238d842267e8.png";